import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const BudgetTabSkeleton: React.FC = () => (
  <div className="space-y-3 py-2">
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="space-y-2 rounded-lg border p-3">
          <Skeleton className="h-5 w-32" />
          <Skeleton className="h-3 w-24" />
        </div>
      ))}
    </div>
    <div className="flex items-center gap-2">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-8 w-56" />
      <div className="flex-1" />
      <Skeleton className="h-8 w-24" />
      <Skeleton className="h-8 w-8" />
      <Skeleton className="h-8 w-44" />
    </div>
    <div className="rounded-md border">
      <Skeleton className="h-10 w-full rounded-none" />
      {Array.from({ length: 10 }).map((_, i) => (
        <div key={i} className="flex h-8 items-center gap-4 border-t px-2">
          <Skeleton className="h-4 w-64" />
          <div className="flex-1" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
        </div>
      ))}
    </div>
  </div>
)
export default BudgetTabSkeleton
